module.exports = __webpack_public_path__ + "img/like.e6389650.svg";